var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36364 16.8667C9.57091 16.8667 10.5455 15.884 10.5455 14.6667C10.5455 13.4493 9.57091 12.4667 8.36364 12.4667C7.15636 12.4667 6.18182 13.4493 6.18182 14.6667C6.18182 15.884 7.15636 16.8667 8.36364 16.8667ZM17.0909 12.4667H11.2727V17.6H5.45455V11H4V22H5.45455V19.8H18.5455V22H20V15.4C20 13.7793 18.6982 12.4667 17.0909 12.4667Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36364 7.74359C9.57091 7.74359 10.5455 6.78154 10.5455 5.58974C10.5455 4.39795 9.57091 3.4359 8.36364 3.4359C7.15636 3.4359 6.18182 4.39795 6.18182 5.58974C6.18182 6.78154 7.15636 7.74359 8.36364 7.74359ZM17.0909 3.4359H11.2727V8.46154H5.45455V2H4V12.7692H5.45455V10.6154H18.5455V16H20V6.30769C20 4.72103 18.6982 3.4359 17.0909 3.4359Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveWhite);
export default __webpack_public_path__ + "static/media/collective-white.405bbc4e99394bfd1efdadce61937a62.svg";
export { ForwardRef as ReactComponent };